import { Children, isValidElement, type ReactElement, type ReactNode } from "react";
import styles from "./StickyButton.module.css";

export type StickyButtonLayout = "stacked" | "sideBySide";

export interface StickyButtonProps {
  /** Up to two `Button` elements — any variant, width, or polymorphic `as`. */
  children: ReactNode;
  /** Stack vertically or place side by side with 16px spacing. */
  layout?: StickyButtonLayout;
  className?: string;
}

/**
 * Padded fill-pure bar for one or two trailing CTAs (drawer footers, sheet
 * chrome, etc.). Pass `Button` children directly; extras beyond two are omitted.
 */
export function StickyButton({
  children,
  layout = "stacked",
  className
}: StickyButtonProps): ReactElement {
  const buttons = Children.toArray(children).filter(isValidElement).slice(0, 2);

  const classes = [
    styles.root,
    layout === "sideBySide" ? styles.sideBySide : styles.stacked,
    className ?? ""
  ]
    .filter(Boolean)
    .join(" ");

  return <div className={classes}>{buttons}</div>;
}
